<template>
    <div class="UserResponseSeparator mt-3">
        <v-divider class="mid"></v-divider>
        <div class="centerXY" style="position: relative; z-index: 1;">
            <span class="text-container">{{$t(text) | capitalize}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ScenarioSeparator",
    props: {
        text: {
            type: String,
            default: 'action'
        }
    }
}
</script>

<style scoped>
    .UserResponseSeparator {
        position: relative;
    }
    .mid {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        z-index: 1;
    }
    .text-container {
        background: #edf0f5;
        padding: 5px;
        z-index: 2;
        border-radius: 5px;
    }
</style>
